export default __webpack_public_path__ + "static/media/product-02 (2).9ef69b39.jpg";